
import { DocumentContentEditor } from "./DocumentContentEditor";

interface ContractViewProps {
  content: any;
  documentId: string;
  onUpdate: () => void;
}

export function ContractView({ content, documentId, onUpdate }: ContractViewProps) {
  return (
    <div className="space-y-8">
      <section className="bg-white rounded-lg p-6 shadow-sm">
        <h2 className="text-2xl font-semibold mb-4">Contract Overview</h2>
        <DocumentContentEditor
          section="Contract Overview"
          content={content.overview}
          documentId={documentId}
          field="overview"
          onUpdate={onUpdate}
        />
      </section>

      <section className="bg-white rounded-lg p-6 shadow-sm">
        <h2 className="text-2xl font-semibold mb-4">Parties Involved</h2>
        <DocumentContentEditor
          section="Parties Involved"
          content={content.parties}
          documentId={documentId}
          field="parties"
          onUpdate={onUpdate}
        />
      </section>

      <section className="bg-white rounded-lg p-6 shadow-sm">
        <h2 className="text-2xl font-semibold mb-4">Terms and Conditions</h2>
        <DocumentContentEditor
          section="Terms and Conditions"
          content={content.terms}
          documentId={documentId}
          field="terms"
          onUpdate={onUpdate}
        />
      </section>

      <section className="bg-white rounded-lg p-6 shadow-sm">
        <h2 className="text-2xl font-semibold mb-4">Payment Terms</h2>
        <DocumentContentEditor
          section="Payment Terms"
          content={content.paymentTerms}
          documentId={documentId}
          field="paymentTerms"
          onUpdate={onUpdate}
        />
      </section>

      <section className="bg-white rounded-lg p-6 shadow-sm">
        <h2 className="text-2xl font-semibold mb-4">Scope of Work</h2>
        <DocumentContentEditor
          section="Scope of Work"
          content={content.scopeOfWork}
          documentId={documentId}
          field="scopeOfWork"
          onUpdate={onUpdate}
        />
      </section>

      <section className="bg-white rounded-lg p-6 shadow-sm">
        <h2 className="text-2xl font-semibold mb-4">Termination Clause</h2>
        <DocumentContentEditor
          section="Termination Clause"
          content={content.termination}
          documentId={documentId}
          field="termination"
          onUpdate={onUpdate}
        />
      </section>

      <section className="bg-white rounded-lg p-6 shadow-sm">
        <h2 className="text-2xl font-semibold mb-4">Legal Provisions</h2>
        <DocumentContentEditor
          section="Legal Provisions"
          content={content.legalProvisions}
          documentId={documentId}
          field="legalProvisions"
          onUpdate={onUpdate}
        />
      </section>
    </div>
  );
}
